/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ScreenerSetting } from './ScreenerSetting';
import {
    ScreenerSettingFromJSON,
    ScreenerSettingFromJSONTyped,
    ScreenerSettingToJSON,
} from './ScreenerSetting';

/**
 * 
 * @export
 * @interface GetScreenerSetting200Response
 */
export interface GetScreenerSetting200Response {
    /**
     * 
     * @type {ScreenerSetting}
     * @memberof GetScreenerSetting200Response
     */
    data?: ScreenerSetting;
}

/**
 * Check if a given object implements the GetScreenerSetting200Response interface.
 */
export function instanceOfGetScreenerSetting200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetScreenerSetting200ResponseFromJSON(json: any): GetScreenerSetting200Response {
    return GetScreenerSetting200ResponseFromJSONTyped(json, false);
}

export function GetScreenerSetting200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetScreenerSetting200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ScreenerSettingFromJSON(json['data']),
    };
}

export function GetScreenerSetting200ResponseToJSON(value?: GetScreenerSetting200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ScreenerSettingToJSON(value.data),
    };
}

